<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.assignments.header.heading')" :has-period-picker="true" :has-pig-type-picker="true">
        <AssignmentTabs></AssignmentTabs>
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import AssignmentTabs from '@/views/dashboard/assignments/AssignmentTabs.vue';

export default defineComponent({
    components: { DashboardContentLayout, AssignmentTabs },
});
</script>
